<template>
  <HeaderContent title="Payment Method" />
  <ActionContent
    ctaText="Add Payment Method"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <PaymentMethodStatistics
    title="Payment Method Statistics"
    :data="statistics"
  />
  <PaymentMethodForm
    :modal="modal"
    :paymentMethodData="paymentMethod"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <PaymentMethodConfirm
    title="Confirmation"
    :uuid="paymentMethodUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(paymentMethodUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </PaymentMethodConfirm>
  <PaymentMethodDataTable
    :data="paymentMethods"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import PaymentMethodForm from "./PaymentMethodForm.vue";
import PaymentMethodDataTable from "@/components/DataTable.vue";
import PaymentMethodStatistics from "@/components/StatisticData.vue";
import PaymentMethodConfirm from "@/components/ModalDialog.vue";
import iconCreditCardEdit from "../../../public/icons/credit-card-edit.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    PaymentMethodForm,
    PaymentMethodDataTable,
    PaymentMethodStatistics,
    PaymentMethodConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const paymentMethodRepository = repositories
      ? repositories.paymentMethod
      : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const paymentMethodUuid = ref(null);
    const paymentMethod = ref({});
    const paymentMethods = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        class: "text-left",
      },
      {
        key: "status",
        label: "Status",
        class: "text-center",
      },
      {
        key: "type",
        label: "Tipe",
        sortable: true,
        class: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "number",
        label: "Number or Code",
        sortable: true,
        class: "text-left",
      },
      {
        key: "owned_by",
        label: "Owned By",
        sortable: true,
        class: "text-left",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: (item) => {
          return item.status === "active" ? "Deactivate" : "Activate";
        },
        variant: (item) => {
          return item.status === "active" ? "danger" : "success";
        },
        icon: "fas fa-check-circle",
        action: (item) => {
          updateStatus(item.uuid);
          // Implement your Update logic here
        },
      },
      {
        label: "Edit",
        variant: "primary",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await paymentMethodRepository
        .getAll()
        .then((res) => {
          paymentMethods.value = res.data.data;
          statistics.value = [
            {
              label: "Total",
              key: "Payment Method",
              value: res.data.data.length,
              color: "primary",
              icon: iconCreditCardEdit,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await paymentMethodRepository
        .getById(uuid)
        .then((res) => {
          paymentMethod.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const updateStatus = async (uuid) => {
      await paymentMethodRepository
        .updateStatus(uuid)
        .then(() => {
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      paymentMethod.value = {};
    };

    const showModal = () => {
      modal.value = true;
      paymentMethod.value = { type: null };
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      paymentMethodUuid.value = uuid;
    };

    const deleteData = async (uuid) => {
      await paymentMethodRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await paymentMethodRepository
        .search(keyword)
        .then((res) => {
          paymentMethods.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      paymentMethodUuid,
      paymentMethod,
      paymentMethods,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
      updateStatus,
    };
  },
};
</script>
